import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { AggregationService } from '../_services/aggregation.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-company-hover-modal',
  templateUrl: './company-hover-modal.component.html',
  styleUrls: ['./company-hover-modal.component.scss']
})
export class CompanyHoverModalComponent implements OnInit {
  @Input() companyInformation: any = {}
  companySelectedList: any[] = [];
  isPersonSearchListing: Boolean = false
  isCompanyInsightsListing: Boolean = false
  isTalentInsightsListing: Boolean = false
  isCompanySelectedList: any[] = [];
  isReportDetails: Boolean = false;
  
  constructor( private router: Router,
     private filterDataHandlerService: FilterDataHandlerService,
     private localstorageservice: LocalStorageService,
     private AggregationService: AggregationService,
     private route: Router
     ) { }

  ngOnInit() {    
    this.isPersonSearchListing = this.filterDataHandlerService.isPersonSearchListingPage();
    this.isCompanyInsightsListing = this.filterDataHandlerService.isRedirectFromCompanyInsightsPage;
    this.isTalentInsightsListing = this.filterDataHandlerService.isRedirectFromTalentInsightsPage;
    this.isCompanySelectedList = this.filterDataHandlerService.fetchFilterData.companySelectedList;
    this.isReportDetails = this.route.url?.startsWith("/report-details");
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
      else if (type == 'website'){
        link = "https://www." + link;
      }
    window.open(link, "_blank")
  }

  viewCompanyInsights(companyInformation){
    const url = `/company-details/${companyInformation.id}/overview`;
    window.open(url, "_blank")
  }

  viewSameCandidate(companyInformation){
    const item = { key: companyInformation.name.toLowerCase(), doc_count: 0 }
    this.companySelectedList.push({ key: item.key, isExcluded: false, isMandatory: false, chipkey: item.key });
    this.filterDataHandlerService.setCompanyFilter(this.companySelectedList)
  }

 checkCompanySelected(companyInformation) {
    if (this.isCompanySelectedList && this.isCompanySelectedList.length > 0) {
        for (let i = 0; i < this.isCompanySelectedList.length; i++) {
            const res = this.isCompanySelectedList[i];
            if (res?.key === companyInformation?.name) {
                return false;
            }
        }
        return true;
    } else {
        return true;
    }
}

}
